import React from 'react';

function Error(props) {
    return (
        <div>
            <div className='flex mt-32 justify-center items-center text-3xl text-richblack-100'>
                <span>Error - 404 Not Found</span>
            </div>
        </div>
    );
}

export default Error;